import React, { useEffect, useState, useContext } from 'react';
import { LoginContext } from './components/Login/LoginContext';
import { Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Login from './components/Login/Login';
import Sidebar from './components/Sidebar/Sidebar';
import Dashboard from './components/Dashboard/Dashboard';
import Managelead from './components/Leads/Manageleads';
import Addlead from './components/Leads/Addlead';
import Distribution from './components/Distribution/Distribution';
import { LoginProvider } from './components/Login/LoginContext';
import Dasboard_user from './components/Dashboard/Dashboard_user';
import Apk from './components/APK/Apk';
import Leadtran from './components/Distribution/Leadtran';
import Lead_head from './components/Distribution/Lead_head';
import Sharecreate from './components/Share/Sharecreate';
import Demokey from './components/Share/Demokey';
import Reportsview from './components/Reports/Reportsview';
import Onlineorder from './components/Onlineorder/Order';
import Onlineorder1 from './components/Onlineorder/Order1';
import Reportable from './components/Reports/Reportable';
import Autosend from './components/Autosendmessage/Autosend';
import Bulkwhatsappsender from './components/Bulkwhatsappsender/Bulkwhatsapp';
import Error from './components/404/Error';
import Training from './components/Training/Training';

function AppContent() {

  const navigate = useNavigate();
  const location = useLocation();
  const [showShortcutModal, setShowShortcutModal] = useState(false);

  useEffect(() => {

    const disableRightClick = (event) => {
      event.preventDefault();
    };

    const disableKeys = (event) => {
      const key = event.key.toLowerCase();

      // CTRL + Q → Open Modal (only when inside sidebar routes)
      if (event.ctrlKey && key === "q") {
        // verify we're on a sidebar subroute
        if (location.pathname.startsWith('/Sidebar')) {
          event.preventDefault();
          setShowShortcutModal(true);
        }
        return;
      }

      // Disable DevTools
      if (
        key === "f12" ||
        (event.ctrlKey && event.shiftKey && key === "c") ||
        (event.ctrlKey && event.shiftKey && key === "j") ||
        (event.ctrlKey && event.shiftKey && key === "k") ||
        (event.ctrlKey && key === "u")
      ) {
        event.preventDefault();
      }

      // ESC → Close modal
      if (key === "escape") {
        setShowShortcutModal(false);
      }
    };

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableKeys);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeys);
    };

  }, [location.pathname]);

  const goTo = (path) => {
    setShowShortcutModal(false);
    navigate(path);
  };

  // close modal when navigating outside sidebar
  useEffect(() => {
    if (!location.pathname.startsWith('/Sidebar')) {
      setShowShortcutModal(false);
    }
  }, [location.pathname]);
  const { loginResult } = useContext(LoginContext);
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            loginResult ? (
              loginResult.user_type === 'team_head' ? (
                <Navigate to="/Sidebar/Dashboard" replace />
              ) : (
                <Navigate to="/Sidebar/Dashboard_user" replace />
              )
            ) : (
              <Login />
            )
          }
        />        <Route path="/Onlineorder" element={<Onlineorder />} />
        <Route path="/Onlineorder1" element={<Onlineorder1 />} />

        <Route path="/Sidebar" element={<Sidebar />}>
          <Route path="Dashboard" element={<Dashboard />} />
          <Route path="Dashboard_user" element={<Dasboard_user />} />
          <Route path="Managelead" element={<Managelead />} />
          <Route path="Addlead" element={<Addlead />} />
          <Route path="Distribution" element={<Distribution />} />
          <Route path="Lead_head" element={<Lead_head />} />
          <Route path="Leadtran" element={<Leadtran />} />
          <Route path="WS" element={<Sharecreate />} />
          <Route path="DK" element={<Demokey />} />
          <Route path="Apk" element={<Apk />} />
          <Route path="Reportsview" element={<Reportsview />} />
          <Route path="Reportable" element={<Reportable />} />
          <Route path="Autoshare" element={<Autosend />} />
          <Route path="BWS" element={<Bulkwhatsappsender />} />
          <Route path="Training" element={<Training />} />
          <Route path="*" element={<Error />} />
        </Route>

        <Route path="*" element={<Error />} />
      </Routes>

      {showShortcutModal && location.pathname.startsWith('/Sidebar') && (
        <div className="shortcut-overlay">
          <div className="shortcut-modal">
            <div className="shortcut-header">
              <h2 className="shortcut-title">Keyboard Shortcuts</h2>

              <span
                className="go-home-btn"
                onClick={() => goTo("/Sidebar/Managelead")}
              >
                Go To Home
              </span>
            </div>
            <ul className="shortcut-list">
              <li onClick={() => goTo("/Sidebar/WS")}>
                <span>WhatsApp Share Templates</span>
                <span className="shortcut-key">WS</span>
              </li>

              <li onClick={() => goTo("/Sidebar/DK")}>
                <span>Demo Key</span>
                <span className="shortcut-key">DK</span>
              </li>

              <li onClick={() => goTo("/Sidebar/BWS")}>
                <span>Bulk WhatsApp Sender</span>
                <span className="shortcut-key">BWS</span>
              </li>

              <li onClick={() => goTo("/Sidebar/Autoshare")}>
                <span>Auto Send</span>
                <span className="shortcut-key">Autoshare</span>
              </li>

              <li onClick={() => goTo("/Sidebar/Training")}>
                <span>Training</span>
                <span className="shortcut-key">Training</span>
              </li>
            </ul>

            <button
              className="shortcut-close"
              onClick={() => setShowShortcutModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <LoginProvider>
      <Router>
        <AppContent />
      </Router>
    </LoginProvider>
  );
}

export default App;